"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalHeader = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("../../styles");
var Heading_1 = require("../Heading");
var HFlow_1 = require("../HFlow");
var VFlow_1 = require("../VFlow");
var hooks_1 = require("../../hooks");
var hooks_2 = require("../../hooks");
var ModalCloseButton_1 = require("./ModalCloseButton");
var ModalHeaderIcon_1 = require("./ModalHeaderIcon");
function ModalHeader(props) {
    var _a = props.hasCloseButton, hasCloseButton = _a === void 0 ? true : _a, style = props.style, onCloseButtonClick = props.onCloseButtonClick;
    var _b = hooks_2.useModalContext(), scroll = _b.scroll, bodyRef = _b.bodyRef, hasLeftSidebar = _b.hasLeftSidebar, hasRightSidebar = _b.hasRightSidebar, setSectionState = _b.setSectionState;
    var isBodyOverflowing = hooks_1.useIsOverflowing(bodyRef, 'vertical');
    var hasSidebar = hasLeftSidebar || hasRightSidebar;
    var showHeaderShadow = scroll === 'body' && isBodyOverflowing;
    var showHeaderBorder = hasSidebar && (scroll === 'full' || (scroll === 'body' && !isBodyOverflowing));
    var _c = styles_1.useStyles(createStyles, showHeaderShadow, showHeaderBorder, hasSidebar), classes = _c.classes, css = _c.css;
    react_1.useEffect(function () {
        setSectionState('hasHeader', true);
        return function () { return setSectionState('hasHeader', false); };
    }, [setSectionState]);
    return (react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 0.5, justifyContent: 'space-between', alignItems: 'flex-start', style: css(classes.header, style), "data-testid": 'modal-header' },
        isHeaderWithChildren(props) ? (props.children) : (react_1.default.createElement(HFlow_1.HFlow, { hSpacing: 1, justifyContent: 'flex-start', alignItems: 'center' },
            props.icon && react_1.default.createElement(ModalHeaderIcon_1.ModalHeaderIcon, { icon: props.icon }),
            react_1.default.createElement(VFlow_1.VFlow, { vSpacing: 0 },
                react_1.default.createElement(Heading_1.Heading, { level: 1, color: 'normal', fontWeight: 'bold' }, props.title),
                props.subtitle && (react_1.default.createElement(Heading_1.Heading, { level: 5, color: 'normal', fontWeight: 'normal' }, props.subtitle))))),
        hasCloseButton && react_1.default.createElement(ModalCloseButton_1.ModalCloseButton, { onClick: onCloseButtonClick })));
}
exports.ModalHeader = ModalHeader;
var isHeaderWithChildren = function (props) { return 'children' in props; };
var createStyles = function (theme, showHeaderShadow, showHeaderBorder, hasSidebar) { return ({
    header: {
        width: '100%',
        gridTemplateColumns: '1fr auto',
        padding: '1.5rem 1rem 1rem 2rem',
        zIndex: 1,
        backgroundColor: hasSidebar ? theme.pallete.gray.c90 : theme.pallete.surface.main,
        borderBottom: showHeaderBorder ? "1px solid " + theme.pallete.divider : 'none',
        boxShadow: showHeaderShadow ? theme.shadows.outer[10] : '',
        gridRow: '1',
        gridColumn: '1 / -1',
    },
}); };
//# sourceMappingURL=ModalHeader.js.map